import { render, staticRenderFns } from "./UPSAuthorizationFormPopup.vue?vue&type=template&id=b58fda4a"
import script from "./UPSAuthorizationFormPopup.vue?vue&type=script&lang=js"
export * from "./UPSAuthorizationFormPopup.vue?vue&type=script&lang=js"
import style0 from "./UPSAuthorizationFormPopup.vue?vue&type=style&index=0&id=b58fda4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports